import { Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback, useRef } from 'react';
import { useDeviceMode } from '../../hooks/useDeviceMode';
import PwaBackground from './PwaBackground';
import PwaHeader from './PwaHeader';
import PwaBottomNav from './PwaBottomNav';
import PwaMoreSheet from './PwaMoreSheet';
import PWAStatus from './PWAStatus';
import PageTransition from '../PageTransition';
import { offlineManager } from '../../utils/offline/manager';
import OfflineFallback from './OfflineFallback';

export default function PwaLayout() {
  const location = useLocation();
  const { isPWA } = useDeviceMode();
  const [moreOpen, setMoreOpen] = useState(false);
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (isPWA) {
      offlineManager.init();
    }
  }, [isPWA]);

  useEffect(() => {
    setMoreOpen(false);
  }, [location.pathname, location.search]);

  const handleRefresh = useCallback(async () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }, []);

  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
  const isSharePage = location.pathname.startsWith('/share/');

  if (isAuthPage || isSharePage) {
    return (
      <>
        <PwaBackground />
        <div className="relative z-10 h-full overflow-y-auto" style={{ height: '100dvh' }}>
          <Outlet />
        </div>
      </>
    );
  }

  return (
    <>
      <PwaBackground />
      <a href="#main-content" className="au-skip-link">Salta al contenuto</a>
      <div className="au-shell">
        {isPWA && <PWAStatus />}
        <PwaHeader onOpenMenu={() => setMoreOpen(true)} />
        <main id="main-content" className="au-main" tabIndex={-1} ref={mainRef}>
          <PageTransition>
            <Outlet />
          </PageTransition>
          <OfflineFallback />
        </main>
        <PwaBottomNav onOpenMore={() => setMoreOpen(true)} />
        <PwaMoreSheet open={moreOpen} onClose={() => setMoreOpen(false)} />
      </div>
    </>
  );
}
